"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiEntry = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const EntryComponent = ({ config, fields, }) => {
    var _a;
    const Component = config.component;
    const className = ((_a = config.classes) === null || _a === void 0 ? void 0 : _a.length) ? config.classes.join(" ") : "";
    const props = config.props || {};
    return (0, jsx_runtime_1.jsx)(Component, Object.assign({ "$data": fields, className: className }, props));
};
const MultiEntry = ({ space, entries, components, }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "multi-entry", children: entries.map((fields, idx) => {
            const componentConfig = components[fields._ctid];
            if (componentConfig) {
                return ((0, jsx_runtime_1.jsx)(EntryComponent, { config: componentConfig, fields: fields }, `multi-entry-${fields._ctid}-${idx}`));
            }
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }) }));
};
exports.MultiEntry = MultiEntry;
